exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sankey-v2[data-v-b7c1d96e] {\n  border-color: #DADADA;\n  border-width: 1px;\n  border-style: solid;\n  display: flex;\n  justify-content: space-between;\n}\n.sankey-v2 .chart.is-loading[data-v-b7c1d96e] {\n    visibility: hidden;\n}\n", ""]);

